import { NewPasswordPage } from './../../../pages/private/new-password/new-password.page';
import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { AlertService } from '../../alert/alert.service';

@Injectable({
  providedIn: 'root'
})
export class NewPasswordCanDeactivateGuard implements CanDeactivate<NewPasswordPage> {

  constructor(private alertService: AlertService) { }

  canDeactivate(component: NewPasswordPage): boolean {
    const valid = component.canDeactivate();
    if (!valid) {
      (async () => {
        await this.alertService.presentAlert("No puedes salir sin antes guardar una nueva contraseña");
      })()
    }
    return valid
  }
}


